import _ from 'lodash';

// TODO: This same file was taken from QuestionLibrary.
// 	Consider moving this and other utilities like ColumnHelper to a Common library.
export const TextHelper = {
	getTextFromArrayProperty(text?: string[], defaultText?: string, delimiter?: string) {
		defaultText = defaultText || '';
		delimiter = delimiter || ', ';
		if (!text || !text.length) {
			return [defaultText];
		}
		// Todo: this can be a helper function.  Idea from https://stackoverflow.com/a/23619085
		const intersperse = (arr: string[], sep: string) => arr.slice(1).reduce((xs, x) => xs.concat([sep, x]), [arr[0]]);

		return intersperse(text, delimiter);
	},
	getTextFromStringProperty(text?: string, defaultText?: string) {
		defaultText = defaultText || '';
		if (!text || text === '') {
			return defaultText;
		}
		return text;
	},
	getCountFromArrayProperty(collection?: any[], defaultText?: string) {
		defaultText = defaultText || '';
		if (!collection || !collection.length) {
			return defaultText;
		}
		const count = collection.length;
		return count.toString();
	},
	doesTextContainSearchCriteria(text?: string, searchText?: string) {
		// Exit early because there is nothing to search on.
		if (text === undefined || text === '' || searchText === undefined || searchText === '') {
			return false;
		}
		const regex = new RegExp('(' + _.escapeRegExp(searchText) + ')', 'ig');
		const splits = text.split(regex);
		// As long as there is more than one item in the splits array, the search text has been found.
		if (splits.length > 1) {
			return true;
		}
		// Otherwise there are no matches.
		return false;
	},
	isValidEmail(email: string) {
		// simple client side validation. Won't catch everything. Be sure to validate on the server as well!
		if (email.trim().startsWith('@') || email.trim().startsWith('.') || email.trim().endsWith('@') || email.trim().endsWith('.')) {
			return false;
		}
		return email.includes('@') && email.includes('.');
	},
	isUniqueEmail(email: string, emails: string[]) {
		const matchingEmails = _.filter(emails, (e: string) => {
			return e === email;
		});
		return matchingEmails.length === 1;
	},
};

export default TextHelper;
